import React from "react";
import LoginComponent from "../components/LoginComponent.js";

class login extends React.Component {
  render() {
    return (
        <div>
          <LoginComponent />
        </div>
    )
  }
}

export default login;
